import { useTranslation } from "react-i18next";
import { Props, StatusOptionValue, StatusQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const StatusQuickfilter = <Q extends StatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  tab,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.recruiting_statuses"; // tRP - translation root path

  const namesOfFileds = {
    position: [
      {
        name: t(`${tRP}.all_positions`),
        value: { isTrueOrFalse: null },
      },
      {
        name: t(`${tRP}.open_positions`),
        value: {
          isTrueOrFalse: true,
        },
      },
      {
        name: t(`${tRP}.closed_positions`),
        value: { isTrueOrFalse: false },
      },
    ],
    hiringClients: [
      {
        name: t(`${tRP}.active`),
        value: {
          isTrueOrFalse: false,
        },
      },
      {
        name: t(`${tRP}.inactive`),
        value: { isTrueOrFalse: true },
      },
      {
        name: t(`${tRP}.all`),
        value: { isTrueOrFalse: null },
      },
    ],
  };

  const options: QuickFilterOption<StatusOptionValue>[] =
    tab === "positions" ? [...namesOfFileds.position] : [...namesOfFileds.hiringClients];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="statuses"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
